import React, { PureComponent, Fragment } from 'react';
import ReactDOM from 'react-dom';

import classNames from 'classnames';
import { canUseDOM } from 'helpers/helpers';
import PropTypes from 'prop-types';

import './Popover.scss';

class Popover extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    blockOnLoading: PropTypes.bool,
    onHide: PropTypes.func,
    onShow: PropTypes.func,
    parentId: PropTypes.string.isRequired,
    show: PropTypes.bool,
    backdrop: PropTypes.bool,
    style: PropTypes.object
  };

  static defaultProps = {
    blockOnLoading: false,
    show: false
  };

  constructor(props) {
    super(props);
    this.state = { open: this.props.show };
    this.el = document.createElement('div');
    this.el.className = classNames('popover', this.props.className);
  }

  getSnapshotBeforeUpdate(prevProps) {
    if (JSON.stringify(prevProps.style) !== JSON.stringify(this.props.style)) {
      return this.props.style.transform;
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (snapshot !== null) {
      this.el.style.transform = snapshot;
    }
  }

  componentDidMount() {
    const parent = document.getElementById(this.props.parentId);

    if (parent !== null) {
      parent.appendChild(this.el);
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (JSON.stringify(nextProps.show) !== JSON.stringify(prevState.open)) {
      return { open: nextProps.show };
    }
    return null;
  }

  componentWillUnmount() {
    const parent = document.getElementById(this.props.parentId);

    if (parent !== null && parent === this.el.parentNode) {
      parent.removeChild(this.el);
    }
  }

  showPopover() {
    if (this.props.onShow) {
      this.props.onShow();
    }
  }

  hidePopover(e) {
    if (e) {
      e.persist();
      e.stopPropagation();
    }
    if (!this.props.blockOnLoading) {
      if (this.props.onHide) {
        this.props.onHide(e);
      }
    }
  }

  renderPopover() {
    if (this.state.open) {
      return (
        <Fragment>
          {this.props.backdrop && (
            <div
              className="ca-backdrop ca-backdrop--active"
              onClick={(e) => this.hidePopover(e)}
            />
          )}
          <div
            className="popover__content"
            onClick={(e) => e.stopPropagation()}
          >
            {' '}
            {this.props.children}{' '}
          </div>
        </Fragment>
      );
    }
  }

  render() {
    return canUseDOM && ReactDOM.createPortal(this.renderPopover(), this.el);
  }
}

export default Popover;
